import { render } from "./CookiesBanner.vue?vue&type=template&id=f335cc06&scoped=true&ts=true"
import script from "./CookiesBanner.vue?vue&type=script&lang=ts"
export * from "./CookiesBanner.vue?vue&type=script&lang=ts"

import "./CookiesBanner.vue?vue&type=style&index=0&id=f335cc06&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f335cc06"]])

export default __exports__